var map = {
	"./src/pages/dashboard/i18n/de.json": 66276,
	"./src/pages/dashboard/i18n/en.json": 7204,
	"./src/shared/i18n/de.json": 46824,
	"./src/shared/i18n/en.json": 45913
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 88704;